import React from "react";
import "./App.css";
import "./index.css";
import { useLocation } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About from "./components/about_us/About";
import Products from "./components/products/Products";
import Contact from "./components/contact_us/Contact";
import Cart from "./components/cart/Cart";
import Privacy from "./components/privacy_policy/Privacy";
import Profile from "./components/profile_page/Profile";
import TermCondition from "./components/terms_conditions/TermCondition";
import PaymentMethod from "./components/payment_method/PaymentMethod";
import WalletInnerPage from "./components/profile_page/wallet_rank/wallet_card/inner_pages/WalletInnerPage";
import StepForm from "./components/step_form/StepForm";
import KYC_Verified from "./components/step_form/kyc_verified/KYC_Verified";
import ProfileSettings from "./components/profile_page/profile_settings/ProfileSettings";
import ProfileEdit from "./components/profile_page/profile_settings/profile_edit/ProfileEdit";
import OrderPlaced from "./components/order_placed/OrderPlaced";
import RankRewards from "./components/profile_page/wallet_rank/rank_card/rank_rewards/RankRewards";
import OrderHistory from "./components/profile_page/order_history/OrderHistory";
import Notification from "./components/profile_page/notifications_tabs/Notifications";
import Our_Community from "./components/profile_page/our_community/Our_Community";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Login from "./components/login/Login";
import Withdraw from "./components/profile_page/wallet_rank/withdraw_earnings/Withdraw";
import UpdateBankDetails from "./components/profile_page/wallet_rank/withdraw_earnings/update_bank_details/UpdateBankDetails";
import BankDetailsUpdated from "./components/profile_page/wallet_rank/withdraw_earnings/update_bank_details/bank_details_updated/BankDetailsUpdated";
import Payment_Payout from "./components/profile_page/wallet_rank/withdraw_earnings/payment_payout_success/Payment_Payout";
import TrackShipmment from "./components/common_components/common_modal/track_shipmment/TrackShipmment";
import Signup from "./components/login/Signup";
import Wallet_History from "./components/profile_page/wallet_history/Wallet_History";
function App() {
  const location = useLocation();
  const hideLayoutPaths = ["/", "/signup"];
  const shouldHideLayout = hideLayoutPaths.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {!shouldHideLayout && <Header />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/terms" element={<TermCondition />} />
        <Route path="/payment" element={<PaymentMethod />} />
        <Route path="/wallet&earnings" element={<WalletInnerPage />} />
        <Route path="/identityVarification" element={<StepForm />} />
        <Route path="/kycVerified" element={<KYC_Verified />} />
        <Route path="/profile-settings" element={<ProfileSettings />} />
        <Route path="/edit-profile" element={<ProfileEdit />} />
        <Route path="/order-placed" element={<OrderPlaced />} />
        <Route path="/rank-rewards" element={<RankRewards />} />
        <Route path="/order-history" element={<OrderHistory />} />
        <Route path="/wallet-history" element={<Wallet_History />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/our-community" element={<Our_Community />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/update-bank-details" element={<UpdateBankDetails />} />
        <Route path="/bank-details-updated" element={<BankDetailsUpdated />} />
        <Route path="/payment-payout" element={<Payment_Payout />} />
        <Route path="/track_shipmment" element={<TrackShipmment />} />
      </Routes>
      {!shouldHideLayout && <Footer />}
    </>
  );
}

export default App;
